import React, { Component } from 'react';
import politicas_header from '../images/politicas_header.png';
import { translate } from 'react-i18next';

class PoliticasHeader extends Component {
  render() {
    const { t } = this.props;
    return(
      <nav className="header-padding" >
        <div >
            <div className="text-center">
              <img alt="IOS OFFICES" className="header-banner" src={politicas_header} />
            </div>
        </div>
      </nav>
    );
  }
}

export default translate('common')(PoliticasHeader);



// WEBPACK FOOTER //
// ./src/guest/PoliticasHeader.js